import React from "react";
import PropTypes from "prop-types";
import { Broadcast, Subscriber } from "react-broadcast";

class EphemeralStore extends React.Component {
  state = this.props.initialState;
  reducer = this.props.reducer;
  actions = this.props.actions;
  autoActions = Object.keys(this.props.actions).reduce((acc, name) => {
    if (typeof this.props.actions[name] === "function") {
      acc[name] = (...params) => this.dispatch(this.props.actions[name](...params));
    } else {
      acc[name] = Object.keys(this.props.actions[name]).reduce((acc2, key) => {
        acc2[key] = (...params) => this.dispatch(this.props.actions[name][key](...params));
        return acc2;
      }, {});
    }
    return acc;
  }, {});

  dispatch = (action, callback) =>
    this.setState(
      prev => this.reduce(prev, action),
      () => (callback ? callback(this.state) : null)
    );
  getState = () => this.state;

  workers = Object.keys(this.props.workers).reduce((acc, name) => {
    acc[name] = this.props.workers[name](this.dispatch, this.getState, this.autoActions);
    return acc;
  }, {});

  reduce = (state = this.state, action) => {
    if (this.reducer.hasOwnProperty(action.type)) {
      return this.reducer[action.type].call(this, state, action);
    } else {
      return state;
    }
  };

  mapTypes = () => {
    return Object.keys(this.props.reducer).reduce((acc, key) => {
      acc[key] = key;
      return acc;
    }, {});
  };

  getValue = () => ({
    storage: this.state,
    types: this.mapTypes(),
    eDispatch: this.dispatch,
    actions: this.actions,
    workers: this.workers,
  });

  renderContent = () => {
    const { children } = this.props;

    if (typeof children === "function") {
      const { workers, storage } = this.getValue();
      return children({ workers, storage });
    }
    return (
      <Broadcast channel={this.props.channel} value={this.getValue()}>
        {children}
      </Broadcast>
    );
  };

  render() {
    return this.renderContent();
  }
}

EphemeralStore.propTypes = {
  initialState: PropTypes.object.isRequired,
  reducer: PropTypes.object.isRequired,
  channel: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  actions: PropTypes.object,
  workers: PropTypes.object,
};
export default EphemeralStore;

export function eConnect(channel) {
  return function connectRoot(Component) {
    return class connectClass extends React.Component {
      render() {
        return (
          <Subscriber channel={channel}>
            {data => <Component {...this.props} {...data} />}
          </Subscriber>
        );
      }
    };
  };
}



// WEBPACK FOOTER //
// ./src/components/EphemeralStore.jsx